customElements.define('popup-component', class extends HTMLElement{

  connectedCallback(){
    let className = this.dataset.className?.split(',') || [];
    className.push('active');
    
    this.classes = {
      className
    }
    
    this.addEventListener('click', e=>{
      const currentTarget = e.target;

      if(!currentTarget.closest('.popup__content') || currentTarget.closest('.jsClose'))
        this.close(); 
    });
    this.appendDocument();
    this.autoShow();
  }

  close(){
    this.classList.remove(...this.classes.className);
    this.setAttribute('aria-hidden', true);

    if(!document.querySelectorAll('popup-component:not([aria-hidden="true"])').length)
      document.body.classList.remove('show-popup');

    this.isActive = null;
  }

  open(callback = null){
    // console.log('open', this);
    this.classList.add(...this.classes.className);
    this.setAttribute('aria-hidden', false);
    this.autoHide();
    document.body.classList.add('show-popup');
    this.isActive = true;

    callback && callback();
  }

  toggle(callback = null){

    this.isActive ? this.close() : this.open();

    callback && callback(this.isActive);
  }

  appendDocument(){
    if (!this.hasAttribute("append-body")) return;

    this.removeAttribute("append-body");

    const existingNode = document.getElementById(this.id);

    if (existingNode && existingNode !== this) {
      existingNode.after(this);
      existingNode.remove();
    }
  }

  autoShow(){
    if (!this.hasAttribute("append-auto")) return;

    this.removeAttribute("append-auto");
    setTimeout(()=>{
      this.open();
    }, 300)
  }

  autoHide(){
    if (!this.hasAttribute("auto-hide")) return;

    if(this.isHiding != null)
      clearTimeout(this.isHiding)

    this.isHiding = setTimeout(()=>{
      this.close();
      this.isHiding = null;
    }, +this.getAttribute('auto-hide'));
  }
});
